// マニュアル（画面とボタンの解説）の動き。本文は docs/tools/screen-guide/run.sh が生成し、screen_guide/index.blade.php が .guide の中に出す。
// 表の行と写真の番号・枠の連動、表の追従、写真の拡大、各画面の「？ この画面の説明」（/screen-guide#ルート名）からの章への移動。

const guide = document.querySelector('.guide');

if (guide) {
    setUpGuide();
}

function setUpGuide() {
    const lightbox = document.getElementById('guide-lightbox');
    const lightboxInner = lightbox.querySelector('.guide-lb__inner');
    let pinned = null;

    // 表の行と、写真の番号・枠を結び付ける（拡大表示の中の写しも同じ data-k を持つ）
    const mark = (key, on) => {
        document.querySelectorAll(`[data-k="${key}"]`).forEach((element) => element.classList.toggle('is-on', on));
    };
    const targetOf = (event) => event.target.closest?.('tr[data-k], .pin[data-k]') ?? null;

    document.addEventListener('mouseover', (event) => {
        const element = targetOf(event);
        if (element) mark(element.dataset.k, true);
    });
    document.addEventListener('mouseout', (event) => {
        const element = targetOf(event);
        if (element && element.dataset.k !== pinned) mark(element.dataset.k, false);
    });

    // 表が画面に収まるときは、長い写真をスクロールしても表が付いてくるようにする（上の帯の高さを除く）
    const stick = () => {
        const room = window.innerHeight - 100;
        guide.querySelectorAll('.shot__table').forEach((table) => {
            const figure = table.previousElementSibling;
            const beside = table.offsetTop === figure.offsetTop;
            table.classList.toggle('is-sticky', beside && table.offsetHeight < room && table.offsetHeight < figure.offsetHeight - 40);
        });
    };
    stick();
    window.addEventListener('load', stick);
    window.addEventListener('resize', stick);

    // 写真の拡大
    const openBox = (frame) => {
        const width = Number(frame.dataset.w) || 800;
        lightboxInner.style.maxWidth = `${Math.round(width * (width <= 430 ? 1.4 : 1.25) + 20)}px`;
        lightboxInner.innerHTML = '';
        const copy = frame.cloneNode(true);
        copy.removeAttribute('tabindex');
        copy.removeAttribute('role');
        copy.removeAttribute('aria-label');
        copy.querySelector('img')?.removeAttribute('loading');
        lightboxInner.appendChild(copy);
        lightbox.classList.add('is-open');
        lightbox.setAttribute('aria-hidden', 'false');
        document.body.classList.add('guide-lb-open');
        lightbox.scrollTop = 0;
    };
    const closeBox = () => {
        if (!lightbox.classList.contains('is-open')) return;
        lightbox.classList.remove('is-open');
        lightbox.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('guide-lb-open');
        lightboxInner.innerHTML = '';
    };

    document.addEventListener('click', (event) => {
        const element = targetOf(event);
        if (element) {
            const key = element.dataset.k;
            if (pinned && pinned !== key) mark(pinned, false);
            pinned = pinned === key ? null : key;
            mark(key, pinned === key);
            if (pinned && element.classList.contains('pin') && !element.closest('.guide-lb')) {
                guide.querySelector(`tr[data-k="${key}"]`)?.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
            }
            return;
        }
        if (event.target.closest('.guide-lb')) {
            closeBox();
            return;
        }
        if (event.target.closest('.guide-backtop')) {
            guide.querySelector('.toc')?.scrollIntoView({ block: 'start', behavior: 'smooth' });
            return;
        }
        const frame = event.target.closest('.guide .shot__frame');
        if (frame) openBox(frame);
    });
    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
            closeBox();
            return;
        }
        const frame = event.target;
        if ((event.key === 'Enter' || event.key === ' ') && frame.classList?.contains('shot__frame') && guide.contains(frame)) {
            event.preventDefault();
            openBox(frame);
        }
    });

    // 各画面の「？ この画面の説明」は /screen-guide#ルート名 で開く。その画面の章（data-routes にルート名がある章）へ移る
    const openRouteHash = () => {
        const key = decodeURIComponent(window.location.hash.slice(1));
        if (!key || document.getElementById(key)) return;
        const section = [...guide.querySelectorAll('[data-routes]')].find((element) => element.dataset.routes.split(' ').includes(key));
        if (!section) return;
        history.replaceState(null, '', `#${section.id}`);
        // ほかの画面から来たときは、ふつうのページ内リンクと同じく一気に移る
        section.scrollIntoView({ block: 'start', behavior: 'instant' });
        section.classList.add('is-target');
        setTimeout(() => section.classList.remove('is-target'), 2800);
    };
    openRouteHash();
    window.addEventListener('hashchange', openRouteHash);
}
